import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { fetchPdfBlobUrl } from '../api/client'

interface Props {
  sessionId: number
  docType: string
}

export function PdfPreview({ sessionId, docType }: Props) {
  const { t } = useTranslation()
  const [blobUrl, setBlobUrl] = useState<string | null>(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let url: string
    fetchPdfBlobUrl(sessionId, docType)
      .then((u) => { url = u; setBlobUrl(u) })
      .catch(() => setError(true))
    return () => { if (url) URL.revokeObjectURL(url) }
  }, [sessionId, docType])

  if (error) return <p className="text-xs text-red-400 mt-1">{t('pdf_preview.error')}</p>
  if (!blobUrl) return <p className="text-xs text-gray-400 mt-1">{t('common.loading')}</p>

  return (
    <iframe
      src={blobUrl}
      className="w-full mt-2 rounded border border-gray-200 dark:border-gray-700"
      style={{ height: '420px' }}
      title={t('pdf_preview.title')}
    />
  )
}
